export default [
  {
    address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    symbol: "AAVE",
  },
  {
    address: "0x4da27a545c0c5b758a6ba100e3a049001de870f5",
    symbol: "stkAAVE",
  },
  {
    address: "0xA700b4eB416Be35b2911fd5Dee80678ff64fF6C9",
    symbol: "aEthAAVE",
  },
] as const
